import { Fragment } from 'react';
import useCesium from '../../../hooks/useCesium';
import useCesiumPlot from '../../../hooks/useCesiumPlot';
import VisualizationControls from './VisualizationControls';

const CesiumContainer = () => {
    const { cesiumContainerRef } = useCesium();

    // Connects WS messages → Cesium plotting (all visuals)
    useCesiumPlot();

    return (
        <Fragment>
            <div ref={cesiumContainerRef} className="position-relative h-100 w-100" />
            <VisualizationControls />
        </Fragment>
    );
};

export default CesiumContainer;
